import PropTypes from 'prop-types'
import { Component } from 'react'

import authenticationAPI from 'api/authentication'
import Email from 'components/authentication/form-fields/Email'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import UpperBackText from 'components/authentication/UpperBackText'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export default class FindCompany extends Component {
  static propTypes = {
    history: PropTypes.object,
    requestPasswordReset: PropTypes.func
  }

  static defaultProps = {
    requestPasswordReset: authenticationAPI.requestPasswordReset
  }

  state = {
    loading: false,
    email: ''
  }

  handleSubmit = async (event) => {
    event.preventDefault()
    const { email } = this.state
    this.setState({ loading: true })

    try {
      await authenticationAPI.findCompany(email)
    } catch (err) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          err,
          'Unable to send request. Please try again later.'
        )
      })
      return this.setState({ loading: false })
    }

    this.setState({ loading: false })
    toast({
      type: 'info',
      text: `Your company name has been emailed to ${email}`
    })
  }

  handleChange = ({ target }) => this.setState({ email: target.value })

  render() {
    return (
      <SignedOutFormContainer>
        <UpperBackText to="/login/saml">Back to login</UpperBackText>
        <SignedOutForm title="Find Company" onSubmit={this.handleSubmit}>
          <Email email={this.state.email} handleChange={this.handleChange} />
        </SignedOutForm>
      </SignedOutFormContainer>
    )
  }
}
